import { render, staticRenderFns } from "./economy-total.vue?vue&type=template&id=6baef340&scoped=true"
import script from "./economy-total.vue?vue&type=script&lang=js"
export * from "./economy-total.vue?vue&type=script&lang=js"
import style0 from "./economy-total.vue?vue&type=style&index=0&id=6baef340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baef340",
  null
  
)

export default component.exports